import * as React from 'react';
import cn from '~modules/cn';
import './fade-in-children.scss';

type Props = React.ComponentPropsWithRef<'div'>;

const FadeInChildren = React.forwardRef<HTMLDivElement, Props>((props, ref) => (
    <div {...props} className={cn('fade-in-children', props.className)} ref={ref}>
        {props.children}
    </div>
));

FadeInChildren.displayName = 'FadeInChildren';

export default FadeInChildren;
